
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";

interface RatingStarsProps {
  rating: number;
  totalRatings: number;
  onRate: (value: number) => void;
  averageRating?: number;
  showAverageStars?: boolean;
}

export function RatingStars({ 
  rating, 
  totalRatings, 
  onRate, 
  averageRating = 0, 
  showAverageStars = false 
}: RatingStarsProps) {
  return (
    <div className="space-y-2">
      {showAverageStars && (
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1">
            {[1, 2, 3, 4, 5].map((value) => (
              <Star
                key={value}
                className={`h-4 w-4 ${
                  value <= Math.round(averageRating) ? "fill-yellow-400 text-yellow-400" : "text-gray-300"
                }`}
              />
            ))}
          </div>
          <span className="text-sm text-muted-foreground">
            ({averageRating.toFixed(1)} • {totalRatings === 1 ? "1 beoordeling" : `${totalRatings} beoordelingen`})
          </span>
        </div>
      )}
      
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1">
          {[1, 2, 3, 4, 5].map((value) => (
            <Button
              key={value}
              variant="ghost"
              size="icon"
              className="h-8 w-8 p-0"
              onClick={() => onRate(value)}
            >
              <Star
                className={`h-4 w-4 ${
                  value <= rating ? "fill-yellow-400 text-yellow-400" : ""
                }`}
              />
            </Button>
          ))}
        </div>
        {!showAverageStars && (
          <span className="text-sm text-muted-foreground">
            ({totalRatings} {totalRatings === 1 ? "beoordeling" : "beoordelingen"})
          </span>
        )}
      </div>
    </div>
  );
}
